module.exports = __webpack_public_path__ + "assets/662deeea7030418accc29e33d0f9dad9.svg";